// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"8280f533","947":"0cdb1c3f"}[chunkId] + ".chunk.js";
};